import React, { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useRecoilState, useRecoilValue, useRecoilCallback } from 'recoil'

import {
  Button,
  SpacingVertical,
  SPACING_32,
  Flex
} from 'mailup-web-components'
import BoxRecipients from './step2/BoxRecipients/BoxRecipients'
import BoxSenderConfig from './step2/BoxSenderConfig/BoxSenderConfig'

import { abTestState, isValidFormState } from '../recoil/state/abtest'
import { pageState } from 'Pages/AbTestWizard/recoil/state/page'
import { initAbTestSendingWizardCallback } from 'Pages/AbTestWizard/recoil/callbacks/callbacks'

import { RECIPIENTS_NONE } from '../const'

const AbTestWizard2Step = () => {
  const intl = useIntl()
  const init = useRecoilCallback(initAbTestSendingWizardCallback, [])
  const [{ loadedStep2 }, setPageState] = useRecoilState(pageState)
  const { step2 } = useRecoilValue(abTestState)
  const isValidForm = useRecoilValue(isValidFormState)

  useEffect(() => {
    if (!loadedStep2) {
      init()
    }
  }, [loadedStep2])

  const handleContinue = () => {
    setPageState(prev => ({
      ...prev,
      wizardStep: prev.wizardStep + 1,
      numberOfStepEnabled: prev.numberOfStepEnabled + 1
    }))
  }

  const handleBtnBack = () => {
    setPageState(prev => ({
      ...prev,
      wizardStep: prev.wizardStep - 1
    }))
  }

  return (
    <>
      <BoxSenderConfig />
      <BoxRecipients />
      <Flex justifyContent='space-between'>
        <Button
          kind='secondary'
          data-mu-test='btn-back'
          onClick={handleBtnBack}
        >
          {intl.formatMessage({ id: 'Load.Common.BtnBack' })}
        </Button>
        <Button
          kind='primary'
          onClick={handleContinue}
          data-mu-test='btn-continue'
          disabled={step2.recipients === RECIPIENTS_NONE || !isValidForm}
        >
          {intl.formatMessage({ id: 'Load.EmailSendingWizard.BtnContinue' })}
        </Button>
      </Flex>
      <SpacingVertical variant={SPACING_32} />
    </>
  )
}

export default AbTestWizard2Step
